
























































import { Component, Vue } from 'vue-property-decorator'
import { IAppUser } from '@/apps/open/types/app'
import { getUserWhitelist, addUserWhitelist, removeUserWhitelist } from '@/apps/open/services/app'
import { getDeveloperSetting } from '@/apps/open/services/developer'
import AddUserDialogBody from '@/apps/open/components/DialogBodys/AddUser.vue'
import { onRequestError } from '@/apps/open/utils'
import DepartmentDialog from '@/apps/open/components/DialogBodys/DepartmentDialog/index.js'

@Component({
  components: {
    DepartmentDialog
  }
})
export default class AppMember extends Vue {
  loading = false
  users: IAppUser[] = []
  selectedUser = {} as IAppUser

  total = 0
  totalPage = 0
  currentPage = 1
  pageSize = 10

  testerlimit = 0

  isShowSelMemberDialog = false
  selectedMembers = []
  disabledAccountIDs: any[] = []

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get id () {
    return this.$route.params['id']
  }

  get remainTotal () {
    const remain = this.testerlimit - this.total
    return remain < 0 ? 0 : remain
  }

  get isShowAddMember () {
    return this.isPrivate ? (this.curEnterprise.developer_type !== 0) : true
  }

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  switchSelMemberDialog () {
    this.isShowSelMemberDialog = !this.isShowSelMemberDialog
  }

  handleSelMember (members: any) {
    this.onAddUser(members[0].id)
  }

  getParams () {
    return {
      app_id: this.id,
      limit: this.pageSize,
      offset: (this.currentPage - 1) * this.pageSize
    }
  }

  async created () {
    this.load()
    this.getTesterLimit()
  }

  async load () {
    this.loading = true
    try {
      const params = this.getParams()
      const resp = await getUserWhitelist(params)
      const data = resp.data
      this.users = data.object_array
      this.total = data.total
      this.totalPage = Math.ceil(this.total / this.pageSize)
      this.disabledAccountIDs = this.users.map(user => user.userid)
    } catch (error) {
      onRequestError(error)
    }
    this.loading = false
  }

  changePage (page: number) {
    this.currentPage = page
    this.load()
  }

  showAddUserDialog () {
    this.$dialog.show({
      title: '添加成员',
      body: AddUserDialogBody,
      bodyProps: {
        submit: this.onAddUser
      },
      buttons: [
        { text: '取消' },
        { text: '确定', type: 'primary', event: 'onOk' }
      ]
    })
  }

  async onAddUser (userid: string) {
    try {
      const res = await addUserWhitelist(this.id, userid)
      const data = res.data.object
      this.total += 1
      this.totalPage = Math.ceil(this.total / this.pageSize)
      if (this.users.length < 10) {
        this.users.push(data)
        this.disabledAccountIDs.push(userid)
      }
      this.$dialog.close()
      this.$message.success('添加成功')
    } catch (error) {
      let message = error.message
      if (error.code === 'UserNotExist') {
        message = '用户不存在'
      } else if (error.code === 'UserAlreadyExist') {
        message = '用户已加入，请勿重复添加'
      }
      onRequestError(error, message)
    }
  }

  showRemoveDialog (appUser: IAppUser) {
    this.selectedUser = appUser
    const dialogBody = `
      <div>
        <div>请确定删除${appUser.username}</div>
        <div>删除成员后，该成员不可以再访问该测试应用</div>
      </div>
    `
    this.$dialog.show({
      title: '删除成员',
      body: dialogBody,
      buttons: [
        { text: '取消' },
        { text: '删除', type: 'danger', fn: this.onRemoveMember }
      ]
    })
  }

  async onRemoveMember () {
    try {
      await removeUserWhitelist(this.id, this.selectedUser.userid)
      this.users = this.users.filter(t => t.userid !== this.selectedUser.userid)
      if (!this.users.length && this.totalPage > 1) {
        this.currentPage -= 1
      }
      this.load()
      this.$dialog.close()
    } catch (error) {
      onRequestError(error)
    }
  }

  async getTesterLimit () {
    try {
      const res = await getDeveloperSetting(this.curEnterprise && this.curEnterprise.developer_id)
      this.testerlimit = res.data.object.tester_limit
    } catch (error) {
      onRequestError(error)
    }
  }
}
